module.exports = __webpack_public_path__ + "files/c3ed85f9eb00a62505be09d77968a79b.png";